<template>
  <a-layout class='index animated fadeIn s_bf'>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="level" label="级别" name="level">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input v-model:value="form.level" placeholder='请输入级别' disabled />
            </a-col>
            <a-col :span="8">
              <p>系统自动按顺序分配</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="level_name" label="级别名称" name="level_name">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input v-model:value="form.level_name" placeholder='请输入级别名称'  maxlength="10" />
            </a-col>
            <a-col :span="8">
              <p>最多10个字</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="growth_value" label="需成长值达" name="growth_value">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input-number v-model:value="form.growth_value" placeholder='请输入成长值' :min="leveData.growth_value?leveData.growth_value:0" style="width:300px"/>
            </a-col>
            <a-col :span="8">
              <a href="javascript:;" @click='typeSetup("grow")'>成长值设置</a>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="remarks" label="备注" name="remarks" >
          <a-row :gutter="16">
            <a-col :span="16">
              <a-textarea v-model:value="form.remarks" showCount :maxlength="200" placeholder="请输入备注" :rows="4" />
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 3 }">
          <a-button type="primary" @click="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
  </a-layout>
</template>
<script>
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { message } from 'ant-design-vue';
  import { getTypeList } from "@/api/store";
  import { iscode } from "@/utils/app";
  import {  setlevelAdd, levelEdit,getLevels } from "@/api/store";
  // 初始化默认筛选项数值
  let defForm = {
    level: '1',
    level_name: '',
    growth_value:'',
    remarks:''
  }
  export default {
    name:'addStoreLevel',
    components: {},
    props: {},
    setup(props,{emit}) {
      const form = ref({ ...defForm });
      const state = reactive({
        leveData:{},
        typeList:[],
        labelCol: { span: 3 },
        wrapperCol: { span: 16 },
        rules: {
          level_name: [
            { required: true, message: '请输入级别名称'}
          ],
          growth_value:[
            {required: true, message: '请选输入所需成长值'}
          ],
        }
      });
      const ruleForm = ref()
      const getLevel = async() =>{
        let res = await getLevels().then(res => res.data);
        if (iscode(res)) {
          form.value.level=1
          if(res.data.level){
              state.leveData = res.data;
              form.value.level=parseInt(res.data.level)+1
          }
        } else {
          message.error(res.msg);
        }
      }
      const onSubmit = () => {
        ruleForm.value.validate().then(async() => {
          const hide = message.loading('正在加载中...', 0);
          let res = await setlevelAdd({...form.value}).then(res => res.data);
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
            emit('storelevelsubmit')
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
          getLevel();
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit
      }
    }
  }
</script>
